/*
Interactivity
Accessibility
Flexbox & Grid
Animation
Layout
Filters
Backgrounds
Effects
Tables
Borders
Lists
Typography
SVG
Sizing
Spacing
Transforms
 */

import webase from "../app/model";
import ComponentFactory from "./ComponentFactory";

export default class ComponentManager {

    constructor(componentDefinition) {
        this.componentDefinition = componentDefinition
        this.styleCategories = Object.keys(webaseStyleMap)
        this.factory = new ComponentFactory()
        this.tempImageUrl = 'https://images.unsplash.com/photo-1540390769625-2fc3f8b1d50c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMjM5NjJ8MHwxfHNlYXJjaHwxNHx8bW91bnRhaW5zfGVufDB8MHx8fDE2NzUxOTc4MjY&ixlib=rb-4.0.3&q=80&w=1080'
    }

    addDataView(view) {
        let classList = ['flex', 'flex-col', 'w-full']
        let viewClasses = ['flex', 'flex-col', 'w-full']

        if(view.view_type === 'details') {
            let containerWrapper = this.factory.createViewItemComponent(view, classList)
            this.componentDefinition.children.push(containerWrapper)
            return
        }

        if(view.view_type === 'gallery') {
            classList = ['flex', 'flex-row', 'flex-wrap', 'w-full']
            viewClasses = ['flex', 'flex-col', 'w-full', 'md:w-1/4', 'border', 'rounded-xl', 'p-3']
        }

        // TODO: make this function really sophisticated to auto generate as much of the component as possible.
        let containerWrapper = this.factory.createComponent(classList)
        let viewItemContainer = this.factory.createViewItemComponent(view, viewClasses)
        containerWrapper.children.push(viewItemContainer)
        this.componentDefinition.children.push(containerWrapper)
    }

    addComponent(componentType, editorState) {
        let childComponent = this.factory.newComponent(componentType)

        // NOTE: This is a pretty BIG hack! (sometimes selecting a container in the top-nav component display
        // doesn't work correctly.
        if(this.componentDefinition.children) {
            this.componentDefinition.children.push(childComponent)
        }
        else if(this.componentDefinition.parent && this.componentDefinition.parent.children) {
            this.componentDefinition.parent.children.push(childComponent)
        }

        // we need to ensure that the image or icon component is selected
        if (componentType === 'Image' || componentType === 'Icon') {
            let eventType = componentType === 'Image' ? 'onImageAdded' : 'onIconAdded'

            setTimeout( () => {
                webase.eventDispatcher.emit(eventType)
                editorState.selectedComponentDefinition = childComponent
            }, 700)
        }

        setTimeout( () => {
            editorState.selectedComponentDefinition = childComponent
        }, 800)
    }

    isTextRequired() {
        if( (this.isLabel() || this.isHeader()) && this.componentDefinition.children &&
            this.componentDefinition.children.length > 0) {
            return false
        }

        return this.componentDefinition.type === 'ButtonComponent' || this.componentDefinition.type === 'HeaderComponent' ||
            this.componentDefinition.type === 'LinkComponent' || this.componentDefinition.type === 'LabelComponent' ||
            this.componentDefinition.type === 'SpanComponent'
    }

    isHeader() {
        return this.componentDefinition.type === 'HeaderComponent'
    }

    isLabel() {
        return this.componentDefinition.type === 'LabelComponent'
    }

    updateFontAwesomeStyle(icon) {
        let faClass = webase.utils.style.findStaticStyle(this.componentDefinition.classes, ['fas', 'far', 'fab'])

        if(faClass) {
            webase.utils.array.remove(this.componentDefinition.classes, faClass)
        }

        faClass = webase.utils.style.findFaClass(this.componentDefinition.classes)

        if(faClass) {
            webase.utils.array.remove(this.componentDefinition.classes, faClass)
        }

        this.componentDefinition.classes.push(`${icon.prefix}`)
        this.componentDefinition.classes.push(`fa-${icon.name}`)
    }

    categoryList() {
        if (this.componentDefinition.type === 'FlexContainer') {
            return ['Container', 'Backgrounds', 'Borders', 'Sizing', 'Spacing', 'Typography', 'Layout', 'Effects',
                'Animation', 'Transforms']
        }

        if (this.componentDefinition.type === 'ButtonComponent') {
            return ['Backgrounds', 'Borders', 'Sizing', 'Spacing', 'Typography', 'Effects', 'Animation', 'Transforms']
        }

        if (this.componentDefinition.type === 'HeaderComponent' || this.componentDefinition.type === 'SpanComponent') {
            return ['Typography', 'Backgrounds', 'Borders', 'Sizing', 'Spacing', 'Effects', 'Animation', 'Transforms']
        }

        if (this.componentDefinition.type === 'FontAwesomeIcon') {
            return ['Typography', 'Borders', 'Sizing', 'Spacing', 'Animation', 'Transforms']
        }

        if (this.componentDefinition.type === 'ListComponent') {
            return ['Spacing']
        }

        if (this.componentDefinition.type === 'ListItemComponent') {
            return ['Container', 'Spacing', 'Typography']
        }

        if (this.componentDefinition.type === 'ImageComponent') {
            return ['Borders', 'Sizing', 'Spacing', 'Layout', 'Filters', 'Effects', 'Animation', 'Transforms']
        }

        return this.styleCategories
    }
}
